"use client";
import dynamic from "next/dynamic";

/*
 * Storefront dev mode's floating button (documents/helpers/devMode.md). A site mounts it from its root layout only
 * when the request has the `_dev_mode` cookie (see the doc), so the panel's code is never loaded for other visitors.
 */
const DevModePanel = dynamic(() => import("./panel"), { ssr: false });

export default function DevModeButton() {
	return <DevModePanel />;
}
